import React from 'react';
import { Box, Typography } from '@mui/material';
import { Phone as PhoneIcon } from '@mui/icons-material';
import { appColors } from '../../Config/Theme';

interface PhoneLinkProps {
  phone?: string | null;
  displayName?: string;
}

const getTelHref = (phone: string): string => {
  const stripped = phone.replace(/[\s()\-.\/]/g, '');
  return `tel:${stripped}`;
};

const PhoneLink: React.FC<PhoneLinkProps> = ({ phone, displayName }) => {
  if (!phone) return null;

  return (
    <Box
      component="a"
      href={getTelHref(phone)}
      aria-label={displayName ? `Call ${displayName} at ${phone}` : `Call ${phone}`}
      onClick={(e: React.MouseEvent) => e.stopPropagation()}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.25,
        flexShrink: 0,
        textDecoration: 'none',
        color: appColors.primary.accent,
        '&:hover': { textDecoration: 'underline' },
      }}
    >
      <PhoneIcon sx={{ fontSize: 13, color: appColors.primary.accent }} />
      <Typography variant="caption" sx={{ color: appColors.primary.accent, fontWeight: 500, whiteSpace: 'nowrap', lineHeight: 1.3 }}>
        {phone}
      </Typography>
    </Box>
  );
};

export default React.memo(PhoneLink);
